<template>
    <div ref="container">
       <a-modal :title="title" width="95%" :visible="visible" :confirmLoading="confirmLoading" :maskStyle="{'top':'93px','left':'154px'}" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" @close="handleCancel" style="top:50px;height: 90%;">
            <TraceModule ref="traceModules" :trace-vueModule="traceVueModule" @getDrawingList="handleGetDrawingList" :isStep="isStep"></TraceModule>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
import TraceModule from '@/views/identifierCode/traceModule.vue';
import { traceModuleEdit, traceModuleDetail } from '@/api/api'
export default {
  name: 'CustomerModal',
  components: {
    TraceModule
  },
  data () {
    return {
      title: '添加模版',
      visible: false,
      confirmLoading: false,
      traceVueModule: [],
      form: this.$form.createForm(this),
      model: {},
      isStep: 1,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
      },
      formModule:[],
      traceModuleForm: {}
    }
  },
    methods: {
        show(data){
            this.traceVueModule = data
            console.log(this.traceVueModule,typeof(this.traceVueModule),'什么呀？？？？？？？？？？？？？？=========================')
        },
        add(data) {
          
          this.traceModuleForm = data
          this.visible = true;
          this.$nextTick(() => {
            if (this.$refs.traceModules && typeof this.$refs.traceModules.showDialog === 'function') {
              this.$refs.traceModules.showDialog(data);
            } else {
              console.error('traceModules 或 showDialog 未正确初始化');
            }
          });
          this.getFormArray(data)
        },
        // 获取表单数据
        async getFormArray(data){
          const params = {
            id: data.id
          }
          const res = await traceModuleDetail(params)
          if( res.code == 200 && res.success == true ){
              this.formModule = res.result.formArray
              this.traceVueModule = res.result.formArray
              console.log(this.traceVueModule,typeof(this.traceVueModule),'这个值=========================')
              this.$refs.traceModules.show(this.traceVueModule);
          }
        },
        handleGetDrawingList(drawingList){
          // 在这里处理接收到的 drawingList 数据
          this.formModule = drawingList
        },
        async handleOk() {
          this.visible = false;
          const that = this
          // 触发表单验证
          let params = {
              id : this.traceModuleForm.id,
              templateName : this.traceModuleForm.templateName,
              remark : this.traceModuleForm.remark,
              formArray: this.formModule
          }
          const res = await traceModuleEdit(params)
          if ( res.code == 200 && res.success == true ) {
              this.$message.success(res.message)
              this.traceVueModule = null
              this.formModule = []
          } else {
              this.$message.error(res.message)
          }
        },
        handleCancel(){
          this.visible = false;
          this.traceVueModule = null
          this.formModule = []
        }
    }
}
</script>
<style lang="less" scoped>

</style>